export default "__VITE_ASSET__Cy2jp1au__"